import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=b1945e86"
import script from "./data-table.vue?vue&type=script&lang=js"
export * from "./data-table.vue?vue&type=script&lang=js"
import style0 from "./data-table.vue?vue&type=style&index=0&id=b1945e86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports